import Divider from '@a24/ui/Divider'
import Icon from '@a24/ui/Icon'
import Popover from '@a24/ui/Popover'
import Title from '@a24/ui/Title'
import ConcessionCard from './concession-card'
import type { SanityConcessionData } from './type'

interface IProps {
  concessions: SanityConcessionData[]
}
const formatConcessionData = (
  concessions: SanityConcessionData[] | undefined
) =>
  concessions?.map((c) => ({
    id: c.externalId,
    title: c.name,
    image:
      c.image && typeof c.image !== 'string' && 'asset' in c.image
        ? c.image
        : undefined,
    price: c.price
  }))
const ConcessionList = ({ concessions }: IProps) => {
  if (!concessions || concessions.length === 0) {
    return null
  }
  return (
    <section className='mb-24'>
      <div className='flex justify-between items-center'>
        <Title className='heading-md mb-6' level='h2' text='Concession items' />
        <Popover
          closeButtonContent={
            <Icon width={24} height={24} id='close-menu-icon' name='close' />
          }
          closeButtonProps={{
            type: 'button',
            className: 'absolute top-0 right-0 z-20 cursor-pointer p-6'
          }}
          className='top-[50%] w-[90%] translate-y-[-50%] backdrop:bg-heritage-black-full/40 rounded bg-heritage-white-full left-[50%] translate-x-[-50%] max-w-[1280px]'
          buttonProps={{
            type: 'button',
            className: 'button-secondary h-fit min-w-[130px]'
          }}
          buttonContent='See full menu'
        >
          <div className='w-full p-6 pb-72 max-h-[90vh]'>
            <Title level='h2' className='heading-sm' text='Browse full menu' />
            <Divider className='mb-6 mt-4' />
            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 pb-6'>
              {formatConcessionData(concessions)
                ?.filter((l) => l.price)
                .map((concession) => (
                  <ConcessionCard key={concession.id} {...concession} />
                ))}
            </div>
          </div>
        </Popover>
      </div>
      <Divider className='mb-8' />
      <div className='grid grid-cols-1 md:grid-cols-2 gap-3'>
        {formatConcessionData(concessions)
          ?.filter((l) => l.price)
          .slice(0, 4)
          .map((concession) => (
            <ConcessionCard key={concession.id} {...concession} />
          ))}
      </div>
    </section>
  )
}

export default ConcessionList
